import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, logout, reset, userLogin, userLogout } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
  Link,
} from "@mui/material";
import login_btn from "../assets/login_btn.png";
import Grid from "@mui/material/Grid";
import "../css/login.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import SimpleSnackbar from "../components/SnackBar/SnackBar";
import Loader from "../components/Loader/Loader";
import { useCallback } from "react";
import logo from '../assets/logo.png'
import eyeOpen from '../assets/eye-open.svg'
import eyeClose from '../assets/eye-close.svg'

const Login = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const isError = useSelector((state) => state.auth.isError);
  const errMsg = useSelector((state) => state.auth.errMsg);
  const isLoading = useSelector((state) => state.auth.isLoading);

  const [validError,setValidError]= useState('');
  const token = localStorage.getItem("token");
  const expirationTime = localStorage.getItem("tokenExpiration");
  const checkTokenExpiration =  () => {
     if (!token || !expirationTime) {
      if(isAuthenticated){
        dispatch(userLogout());
      }
    } 
  }
  // function setLogoutTimer(expirationTime) {
  //   const currentTime = Date.now();
  //   const timeoutDuration = expirationTime - currentTime;
  //   let notificationTime = timeoutDuration - 30000;
  //   if (Math.sign(notificationTime) === -1) {
  //     dispatch(userLogout());
  //   }
  //   setTimeout(() => {
  //     checkTokenExpiration();
  //   }, notificationTime);
  // }

  useEffect(() => {
    checkTokenExpiration();
  }, [token]);

  const handleLogin = (e) => {
    e.preventDefault();
    if(user.email === '' ||  user.password === '') {
      setValidError('All Fields Required');
      setTimeout(() => {
        setValidError('')
      }, 3000);
    }  
    else{
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email)){
        setValidError('Enter valid email');
        setTimeout(() => {
          setValidError('')
        }, 3000);
      }else{

        dispatch(userLogin({ ...user, rememberMe }));
      }
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => { 
    if (isAuthenticated) {
      history("/");
    }
  }, []);
  useEffect(() => {
    if (isError) {
      const timer = setTimeout(() => {
        dispatch(reset());
      }, 3000);
      return () => clearTimeout(timer);  
    }
  }, [isError, dispatch]);

  // const maskedPassword = showPassword ? user.password : '*'.repeat(password.length);

  return (
    <Grid
      className="login"
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      style={{ height: "100vh", background: "#F6F7FF" }}
    >
      <Loader message={"Loading"} show={isLoading} />
      <SimpleSnackbar open={(isError || validError) ? true : false} message={errMsg || validError} variant={"error"} />

      <Grid container className="card_img">
        <Grid item xs={12} md={6} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }} className="login_image"></Grid>

        <Grid
          item
          xs={12}
          md={6}
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ padding: "20px" }}
        >
          <Box
            component="form"
            noValidate
            onSubmit={handleLogin}
            width={'80%'}
            className="login_form"
           >
            <Box component={"div"} textAlign={"center"}>
              <img src={logo} alt="logo" width={200}/>
              {/* <Typography variant="h5" mt={3}>
                Welcome Back!
              </Typography> */}
              <Typography fontSize={"16px"} fontWeight={500} marginBottom={2}>
                Login to continue
              </Typography>
            </Box>
            <Box mb={2} mt={2}>
              <InputLabel sx={{ marginBottom: "5px" }}>Email</InputLabel>
              <input
                type="email"
                name="dummy"
                autoComplete="off"
                style={{ display: "none" }}
              />
              <TextField
                fullWidth
                type={"email"}
                variant={"outlined"}
                placeholder="Enter your email"
                size="small"
                InputProps={{
                  style: {
                    outline: 'none',
                    boxShadow: 'none',
                  },
                }}
                value={user.email}
                onChange={(e) => {
 
                    setUser({ ...user, email: e.target.value });
                  
                }}
                autoComplete="new-username"
              />
            </Box>

            {/* Password Input */}
            <Box mb={1}>
              <InputLabel sx={{ marginBottom: "5px" }}>Password</InputLabel>
              <input
                type="password"
                name="fakepasswordremembered"
                style={{ display: "none" }}
              />

              <FormControl fullWidth variant="outlined" size="small">
                <OutlinedInput
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  autoComplete="new-pass"
                  value={user.password}
                  onChange={(e) => {
                    setUser({ ...user, password: e.target.value });
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {!showPassword ? <img src={eyeClose} width={'20px'}/> : <img src={eyeOpen} width={'20px'}/>}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </Box>
            <Box
              component={"div"}
              mb={3}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                    />
                  }
                  label={
                    <Typography variant="p" fontSize={"14px"} color={"#747980"}>
                      Remember me
                    </Typography>
                  }
                />
              </FormGroup>
              {/* <Link
                href="#"
                underline="none"
                fontSize={"14px"}
                color={"#3665C5"}
              >
                Forgot Password?
              </Link> */}
            </Box>

            {/* Login Button */}
            <Button
              type="submit"
              size="large"
              variant="contained"
              sx={{background:"#358ad4",borderRadius:"8px",'&:hover': {
                    background:"#358ad4da"
                  } }}
              fullWidth
            >
              Login 
              {/* <span style={{ display: "flex", marginLeft: "10px" }}>
                <img src={login_btn} width={14} height={15} />
              </span> */}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Login;
